/**
 * Cart Action Types and Actions
 * Ported from legacy nv-nav-cart-build
 */

// Action Types (matching legacy implementation)
export const actionTypes = {
  SET_CART: "SET_CART",
  ADD_ITEM_TO_CART: "ADD_ITEM_TO_CART",
  REMOVE_ITEM_FROM_CART: "REMOVE_ITEM_FROM_CART",
  INC_ITEM_QUANTITY: "INC_ITEM_QUANTITY",
  DEC_ITEM_QUANTITY: "DEC_ITEM_QUANTITY",
  UPDATE_PRODUCTS: "UPDATE_PRODUCTS",
  CLEAR_CART: "CLEAR_CART",
  UPDATE_INVENTORY: "UPDATE_INVENTORY",
};

// Action Interfaces
export interface CartAction {
  type: string;
  id?: string;
  cart?: any[];
  quantity?: number;
  category?: string;
  products?: any[];
  quantityRemoved?: number;
  lastAction?: CartAction | null;  // For SET_CART action to preserve lastAction
}

export interface CartProduct {
  id: string;
  sku: string;
  name: string;
  isQuantity: boolean;
  quantity: number;
  activeTab?: string;
  category: string;
  productType: string;
  listPrice: number;
  unitPrice: number;
  pricing: {
    listPriceWithQuantity: number;
    salePriceWithQuantity: number;
    unitPrice: number;
  };
  totalPrice: string;
  productIsInStock: boolean;
  productIsAllowsBackorders: boolean;
  expires: Date;
  locale: string;
  minimumQuantity: number;
  limitPerCustomer: number | null;
  availableQuantity: number | null;
  promo?: any;
}

export interface CartStateInterface {
  cart: CartProduct[];
  lastAction: CartAction | null;
  activeTab?: string;
}

// Make actionTypes available globally (for legacy compatibility)
if (typeof window !== 'undefined') {
  (window as any).actionTypes = actionTypes;
}

